import React from "react";
import Footer from "components/Footer";
import styled from "styled-components";
import logo from "assets/logo.svg";
import RouteMap from "components/route/RouteMap";
import ROUTES from "./routes";
import background from 'assets/auth-background.svg';

const AuthViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding-top: 60px;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-position: center 110px;
  background-size: 100%;
`;

const Header = styled.header`
  margin-bottom: 16px;
  text-align: center;
  h1 {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    font-size: 32px;
    img {
      height: 44px;
      margin-right: 16px;
    }
  }

  h2 {
    margin-top: 12px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
`;

const Content = styled.section`
  flex: 1;
  width: 368px;
`;

const AuthView: React.FC = () => (
  <AuthViewContainer>
    <Header>
      <h1>
        <img src={logo} alt="lrms logo" />
        滑坡实时监测预警系统
      </h1>
      <h2>Landslide Monitoring System</h2>
    </Header>
    <Content>
      <RouteMap config={ROUTES} />
    </Content>
    <Footer />
  </AuthViewContainer>
);

export default AuthView;
